export default __webpack_public_path__ + "static/media/bundle.js.24f367f4.map";